(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(function($) {
  if (!customElements.get('cdz-grid-col')) {
    customElements.define('cdz-grid-col', class CdzGridCol extends HTMLElement {
      constructor() {
        super();
        var t, $list, $btnGrp = $(this),
        reset = () => {
          $list = $('[role="collection-product-list"]');
          var curCol = $list.css('--items-count');
          if (curCol != 1) {
            $list.css('--items-count', '');
            $('[data-column].active', $btnGrp).removeClass('active');
            curCol = parseInt($list.css('--items-count'));
            $('[data-column="' + curCol + '"]', $btnGrp).addClass('active');
          }
        };
        $('[data-column]', $btnGrp).on('click', function (e) {
          $list = $('[role="collection-product-list"]');
          e.preventDefault();
          var $btn = $(this), cols = parseInt($btn.data('column'));
          if (t) clearTimeout(t);
          $list.addClass('changing-col').css({'--items-count': cols});
          if (cols == 1) {
            $list.addClass('cdz-mode-list').removeClass('cdz-mode-grid');
          } else {
            $list.removeClass('cdz-mode-list').addClass('cdz-mode-grid');
          }
          $btn.addClass('active').siblings().removeClass('active');
          t = setTimeout(() => {
            $list.removeClass('changing-col');
          }, 1000);
        });
        reset();
        $(window).on('cdz_winwidth_changed', reset);
      }
    });
  }
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function($) {
  $('body').on('click', '[role=add-pd-review]', (e) => {
    e.preventDefault();
    var $reviewBlock = $('[data-block-handle="reviews"]').first(), $tab = $reviewBlock.parents('.tab-content').first();
    if ($tab.length) {
      $tab.parents('.cdz-tabs').first().find('a.tab-title[href="#' + $tab.attr('id') + '"]').trigger('click');
      setTimeout(() => {
        $('html,body').animate({scrollTop: $tab.offset().top - 100}, 600);
      }, 100);
    }
  });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
